export class Package {
    cantidad: string;
    largo: string;
    alto: string;
    ancho: string;
    peso: string;
}